import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  Outlet,
  useLocation,
} from "react-router-dom";
import { ROUTES } from "./constants/routes";
import AuthPhoneNUmber from "./container/auth/phone-number";
import AuthPhoneOTP from "./container/auth/phone-otp";
import UserPersonalDetails from "./container/onboarding/personal-details";
import PersonalProfile from "./container/onboarding/profile-pic";
import Home from "./container/home";
import Socials from "./container/onboarding/socials";
import BusinessDetails from "./container/onboarding/professional-details";
import { getCookies } from "./helpers/storage";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Header from "./components/common/header";
import AcademyRoutes from "./routes/academy";
import Events from "./container/events";
import User from "./container/user";
import Leaderboard from "./container/leaderboard";
import Search from "./container/search";
import Wallet from "./components/wallet";
import ChatContainer from "./components/chat";
import Bookmark from "./container/home/Bookmark";
import UserActivity from "./container/user/UserActivity";
import ActivityPage from "./container/home/Activity";
import MembershipPage from "./components/Home/membership";
import CongratulationsScreen from "./components/academy/course/module-completed";
import FireCalculator from "./components/tools/fire-calculator";
import LogoutModal from "./components/common/logout";
import useCheckMobileScreen from "./hooks/mobilescreen-hooks";
import MobileScreen from "./components/Mobile";
import MoneyRoutes from "./routes/money";
import CleartaxIframe from "./components/money/tax/cleartax-iframe";

const App = () => {
  const isMobileScreen = useCheckMobileScreen();
  const PrivateRoute = () => {
    const location = useLocation();
    const accessToken = getCookies("accessToken");
    const refreshToken = getCookies("refreshToken");

    if (!accessToken || !refreshToken) {
      return <LogoutModal />;
    }

    return (
      <>
        <Header />
        <Outlet />
        <ChatContainer isRightPanelHide={location.pathname !== ROUTES.HOME} />
      </>
    );
  };

  const PublicRoute = () => {
    const accessToken = getCookies("accessToken");
    const refreshToken = getCookies("refreshToken");

    if (accessToken && refreshToken) {
      return <Navigate to={ROUTES.HOME} />;
    }
    return <Outlet />;
  };

  return isMobileScreen ? (
    <MobileScreen />
  ) : (
    <>
      <Router>
        <Routes>
          <Route
            path="/"
            element={<Navigate to={ROUTES.AUTH_PHONE_NUMBER} replace />}
          />
          <Route element={<PublicRoute />}>
            <Route
              path={ROUTES.AUTH_PHONE_NUMBER}
              element={<AuthPhoneNUmber />}
            />
            <Route path={ROUTES.AUTH_PHONE_OTP} element={<AuthPhoneOTP />} />
          </Route>
          <Route
            path={ROUTES.ONBOARDING_PERSONAL_DETAILS}
            element={<UserPersonalDetails />}
          />
          <Route
            path={ROUTES.ONBOARDING_PROFILE_PIC}
            element={<PersonalProfile />}
          />
          <Route
            path={ROUTES.ONBOARDING_PROFESSIONAL_DETAILS}
            element={<BusinessDetails />}
          />
          <Route path={ROUTES.ONBOARDING_SOCIALS} element={<Socials />} />
          <Route element={<PrivateRoute />}>
            <Route path={ROUTES.LEADERBOARD} element={<Leaderboard />} />
            <Route path={ROUTES.WALLET} element={<Wallet />} />
            <Route path={ROUTES.HOME} element={<Home />} />
            <Route path={ROUTES.ACTIVITY} element={<ActivityPage />} />
            <Route path={ROUTES.BOOKMARKS} element={<Bookmark />} />
            <Route path={ROUTES.USER_PROFILE} element={<User />} />
            <Route path={ROUTES.USER_ACTIVITY} element={<UserActivity />} />
            <Route path={ROUTES.EVENTS} element={<Events />} />
            <Route path={ROUTES.EVENT} element={<Events />} />
            <Route path={ROUTES.SEARCH} element={<Search />} />
            <Route path={ROUTES.MEMBERSHIP} element={<MembershipPage />} />
            {/* <Route path={ROUTES.MONEY_PARENT} element={<MoneyRoutes />} /> */}
            <Route path={ROUTES.MONEY_PARENT} element={<MoneyRoutes />} />
            <Route path={ROUTES.FIRE_CALCULATOR} element={<FireCalculator />} />
            <Route
              path={ROUTES.ACADEMY_MODULE_COMPLETED}
              element={<CongratulationsScreen />}
            />

            <Route
              path={ROUTES.ACADEMY_PARENT}
              element={<AcademyRoutes />}
            ></Route>
            <Route path={ROUTES.CLEARTAX} element={<CleartaxIframe />}></Route>
          </Route>
        </Routes>
      </Router>
      <ToastContainer />
    </>
  );
};

export default App;
